import { any } from "ramda";

const DREAME_HOSTS_COMPANY = ['dreame', 'kitfort'];

export const getNeedBlock = () => any(host => window.location.host.startsWith(host), DREAME_HOSTS_COMPANY);
